<template lang="pug">
    .component-header-columns
        .row
            .columns(v-for="(column, key) in columns", :class="{shrink: column===''}") {{column}}
</template>
<script type="text/babel">
    export default{
        name: "HeaderColumns",
        props: ['columns']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// HeaderColumns.vue?273cd069